export default __webpack_public_path__ + "static/media/outlookadd.f6094f15.svg";